import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Logo } from "./Logo";
import { NAV, CONTACT } from "@/lib/site";
import { useGo } from "@/lib/nav";

export const Footer = () => {
  const ref = useRef(null);
  const go = useGo();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end end"] });
  const y = useTransform(scrollYProgress, [0, 1], ["40%", "0%"]);

  return (
    <footer ref={ref} data-testid="site-footer" className="relative overflow-hidden border-t border-white/[0.08] bg-[#0A0A0A] px-5 pt-20 md:px-10">
      <div className="mx-auto grid max-w-[1500px] gap-12 md:grid-cols-12">
        <div className="text-neutral-50 md:col-span-4">
          <Logo />
          <p className="mt-6 max-w-xs text-sm text-neutral-500">New construction decks, covered porches, siding and exterior upgrades. Est. 2022. {CONTACT.region}.</p>
        </div>
        <div className="md:col-span-3 md:col-start-6">
          <div className="eyebrow mb-5">Explore</div>
          <ul className="space-y-3">
            {NAV.map((n) => (
              <li key={n.id}><button data-testid={`footer-link-${n.id}`} onClick={() => go(n)} className="text-neutral-400 transition-colors hover:text-neutral-50">{n.label}</button></li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3">
          <div className="eyebrow mb-5">Contact</div>
          <ul className="space-y-3 text-neutral-400">
            <li><a data-testid="footer-phone-link" href={CONTACT.phoneHref} className="hover:text-neutral-50">{CONTACT.phone}</a></li>
            <li><a data-testid="footer-email-link" href={`mailto:${CONTACT.email}`} className="hover:text-neutral-50">{CONTACT.email}</a></li>
            <li>Johnson City · Kingsport · Bristol</li>
          </ul>
        </div>
      </div>
      <motion.div style={{ y }} className="pointer-events-none mt-16 select-none whitespace-nowrap text-center font-display text-[21vw] font-extrabold leading-[0.8] tracking-tighter text-outline-amber">
        Newland
      </motion.div>
      <div className="mx-auto flex max-w-[1500px] flex-col justify-between gap-2 border-t border-white/[0.08] py-6 font-mono text-[0.65rem] uppercase tracking-[0.2em] text-neutral-600 md:flex-row">
        <span>© {new Date().getFullYear()} Newland Construction · Est. 2022</span>
        <span>Owner-operated by Matt Newland · Free estimates</span>
      </div>
    </footer>
  );
};
